import { render, staticRenderFns } from "./FixedBearingsFormVisual2D.vue?vue&type=template&id=71036c21"
import script from "./FixedBearingsFormVisual2D.vue?vue&type=script&lang=js"
export * from "./FixedBearingsFormVisual2D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports